import UserProfilePage, { getServerSideProps as UserProfilePageGetServerSideProps } from './index';

const UserProfileSlugPage = UserProfilePage;

export const getServerSideProps = UserProfilePageGetServerSideProps;

export default UserProfileSlugPage;
